import { Component, HostListener, OnDestroy } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { ToggleService } from './toggle.service';
import { CommonModule, NgClass } from '@angular/common';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sidebar',
    imports: [NgScrollbarModule, MatExpansionModule, RouterLinkActive, RouterModule, RouterLink, NgClass, CommonModule],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnDestroy {
    user: any;
    isSidebarToggled = false;
    isToggled = false;

    isProdShiftUser = false;
    isITSupportUser = false;
    isStockTakeUser = false;
    isCalibrationUser = false;
    isDefectReportUser = false;
    isITAssetUser = false;
    isEngineeringUser = false;
    isEngineeringAdminUser = false;
    isUser = false;
    isPersonnelUser = false;
    isPersonnelAdminUser = false;
    isAppAdminUser = false;

    kpiOpen = false;
    panelOpenState = false;

    private subscriptions = new Subscription();

    constructor(
        private router: Router,
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService
    ) {
        this.subscriptions.add(
            this.toggleService.isSidebarToggled$.subscribe(val => {
                this.isSidebarToggled = val;
            })
        );
        this.subscriptions.add(
            this.themeService.isToggled$.subscribe(val => {
                this.isToggled = val;
            })
        );
    }

    ngOnInit() {
        this.subscriptions.add(
            this.router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    this.user = localStorage.getItem('user');
                    this.user = (JSON.parse(this.user))?.user_info;
                    const groups = this.user?.roles;
                    this.isUser = groups.some((g: any) => g.name === 'CultechWebPortalUsers');
                    this.isProdShiftUser = groups.some((g: any) => g.name === 'CultechWebPortalProdShiftUser' || g.name === 'CultechWebPortalAdmin');
                    this.isITSupportUser = groups.some((g: any) => g.name === 'CultechWebPortalITSupportUser' || g.name === 'CultechWebPortalAdmin');
                    this.isStockTakeUser = groups.some((g: any) => g.name === 'CultechWebPortalStockTakeUser' || g.name === 'CultechWebPortalAdmin');
                    this.isCalibrationUser = groups.some((g: any) => g.name === 'CultechWebPortalCalibrationsUser' || g.name === 'CultechWebPortalAdmin');
                    this.isDefectReportUser = groups.some((g: any) => g.name === 'CultechWebPortalDefectReportUser' || g.name === 'CultechWebPortalAdmin');
                    this.isITAssetUser = groups.some((g: any) => g.name === 'CultechWebPortalITSupportUser' || g.name === 'CultechWebPortalAdmin');
                    this.isEngineeringUser = groups.some((g: any) => g.name === 'CultechWebPortalEngineeringUser' || g.name === 'CultechWebPortalAdmin');
                    this.isEngineeringAdminUser = groups.some((g: any) => g.name === 'CultechWebPortalEngineeringAdmin' || g.name === 'CultechWebPortalAdmin');
                    this.isPersonnelUser = groups.some((g: any) => g.name === 'CultechWebPortalAuthManager' || g.name === 'CultechWebPortalAdmin' || g.name === 'CultechWebPortalApprovalManager' || g.name === 'CultechWebPortalITSupportUser');
                    this.isPersonnelAdminUser = groups.some((g: any) => g.name === 'CultechWebPortalAdmin');
                    this.isAppAdminUser = this.user.is_superuser;
                    if (!localStorage.getItem('token')) {
                        localStorage.clear();
                        this.router.navigate(['']);
                    }
                }
            })
        );
    }

    // Reset sidebar when resizing back to desktop so layout isn't left broken
    @HostListener('window:resize')
    onResize(): void {
        if (window.innerWidth > 1199 && this.isSidebarToggled) {
            this.toggleService.reset();
        }
    }

    toggle() {
        this.toggleService.toggle();
    }

    toggleTheme() { this.themeService.toggleTheme(); }
    toggleSidebarTheme() { this.themeService.toggleSidebarTheme(); }
    toggleRightSidebarTheme() { this.themeService.toggleRightSidebarTheme(); }
    toggleHideSidebarTheme() { this.themeService.toggleHideSidebarTheme(); }
    toggleHeaderTheme() { this.themeService.toggleHeaderTheme(); }
    toggleCardBorderTheme() { this.themeService.toggleCardBorderTheme(); }
    toggleRTLEnabledTheme() { this.themeService.toggleRTLEnabledTheme(); }

    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        const rememberMe = localStorage.getItem('rememberMe') === 'true';
        if (!rememberMe) {
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('refresh_token_issued_at');
            localStorage.removeItem('rememberMe');
        }
        localStorage.clear();
        this.router.navigate(['/authentication/logout']);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}